import React from 'react';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { Portfolio } from '../components/Portfolio';
import { Businesses } from '../components/Businesses';
import { Story } from '../components/Story';
import { Awards } from '../components/Awards';
import { Testimonials } from '../components/Testimonials';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
import { EventsPromotions } from '../components/EventsPromotions';
interface LandingPageProps {
  onNavigate?: (page: 'home' | 'about' | 'contact' | 'business', slug?: string) => void;
}
export function LandingPage({
  onNavigate
}: LandingPageProps) {
  return <main className="min-h-screen bg-white" data-id="element-623">
      <Hero data-id="element-624" />
      <Stats data-id="element-625" />
      <Portfolio onNavigate={onNavigate} data-id="element-626" />
      <Businesses onNavigate={onNavigate} data-id="element-627" />
      <Story data-id="element-628" />
      <Awards data-id="element-629" />
      <Testimonials data-id="element-630" />
      <EventsPromotions data-id="element-631" />
      <Newsletter data-id="element-632" />
      <Footer data-id="element-633" />
    </main>;
}